'use strict';

var React = require('react');

var SvgAppsFilledMajor = function SvgAppsFilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.25a1 1 0 0 1 1 1v1.25h1.25a1 1 0 1 1 0 2h-1.25v1.25a1 1 0 1 1-2 0v-1.25h-1.25a1 1 0 1 1 0-2h1.25v-1.25a1 1 0 0 1 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 4a1.75 1.75 0 0 0-1.75 1.75v2.75a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 16a1.75 1.75 0 0 1-1.75-1.75v-2.75a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 16a1.75 1.75 0 0 0 1.75-1.75v-2.75a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h2.75Z"
  }));
};
SvgAppsFilledMajor.displayName = "AppsFilledMajor";

exports.SvgAppsFilledMajor = SvgAppsFilledMajor;
